// extracted by mini-css-extract-plugin
export default {"order-management-item":"OrderDetailAccordionButton_order-management-item__L8jVC","total-container":"OrderDetailAccordionButton_total-container__F+6xt"};